export const SETTINGS_SECTIONS = [
  'connections',
  'memory',
  'permissions',
  'activity',
  'security',
  'privacy',
] as const;
export type SettingsSectionId = (typeof SETTINGS_SECTIONS)[number];

export function isSettingsSection(value: string | undefined): value is SettingsSectionId {
  return (SETTINGS_SECTIONS as readonly string[]).includes(value ?? '');
}
